import React from 'react';
import ContactForm from '../contact/ContactForm';
import { useLanguage } from '../../contexts/LanguageContext';
import { getLocalizedValue, siteContent } from '../../data/siteContent';
import { getLocalizedSchedule } from '../../data/staticSchedule';
import '../../styles/Contact.css';

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" className="contact-info-svg agua-teal-icon-shadow" aria-hidden="true">
    <path
      d="M6.6 10.8c1.3 2.6 3.9 5.2 6.6 6.6l2.2-2.2c.3-.3.8-.4 1.2-.3 1.3.4 2.6.6 4 .6.7 0 1.2.5 1.2 1.2v3.5c0 .7-.5 1.2-1.2 1.2C10.3 22 2 13.7 2 3.4 2 2.7 2.5 2.2 3.2 2.2h3.6c.7 0 1.2.5 1.2 1.2 0 1.4.2 2.8.6 4 .1.4 0 .9-.3 1.2l-1.7 2.2z"
      fill="currentColor"
    />
  </svg>
);

const LocationIcon = () => (
  <svg viewBox="0 0 24 24" className="contact-info-svg agua-teal-icon-shadow" aria-hidden="true">
    <path
      d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5z"
      fill="currentColor"
    />
  </svg>
);

const MessageIcon = () => (
  <svg viewBox="0 0 24 24" className="contact-info-svg agua-teal-icon-shadow" aria-hidden="true">
    <path
      d="M4 4h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H8.4L4 21.5V18c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zm0 3.1v.4l8 4.6 8-4.6v-.4L12 11.7 4 7.1z"
      fill="currentColor"
    />
  </svg>
);

const ContactSection = () => {
  const { language } = useLanguage();
  const labels = siteContent.contact;
  const title = getLocalizedValue(siteContent.navigation.contact, language);
  const locations = getLocalizedSchedule(language).sort((left, right) => (
    left.id === 'center' ? -1 : right.id === 'center' ? 1 : 0
  ));
  const phoneHref = labels.phone.replace(/\s/g, '');
  const phoneDisplay = labels.phone.replace(/^\+31\s?/, '0');

  return (
    <section className="section contact-section" id="contact">
      <div className="container">
        <h2 className="section-title">{title}</h2>
        <p className="contact-intro">
          {getLocalizedValue(labels.intro, language)}
        </p>

        <div className="contact-content-grid">
          <div className="contact-form-container">
            <h3 className="form-title contact-section-title">
              <span className="contact-info-icon">
                <MessageIcon />
              </span>
              <span>{getLocalizedValue(labels.formTitle, language)}</span>
            </h3>
            <ContactForm />
          </div>

          <div className="contact-info-stack">
            <section className="contact-info-frame">
              <h3 className="contact-info-title contact-section-title">
                <span className="contact-info-icon">
                  <PhoneIcon />
                </span>
                <span>{getLocalizedValue(labels.phoneLabel, language)}</span>
              </h3>
              <a className="btn btn-primary agua-crooked-frame contact-phone-button" href={`tel:${phoneHref}`}>
                {phoneDisplay}
              </a>
            </section>

            <section className="contact-info-frame">
              <h3 className="contact-info-title contact-section-title">
                <span className="contact-info-icon">
                  <LocationIcon />
                </span>
                <span>{getLocalizedValue(labels.locationLabel, language)}</span>
              </h3>
              <div className="contact-location-list">
                {locations.map((location) => {
                  const cityLine = `${location.postalCode} Rotterdam`;
                  const fullAddress = `${location.address}, ${cityLine}`;

                  return (
                    <a
                      className="contact-location"
                      href={`https://maps.google.com/?q=${encodeURIComponent(fullAddress)}`}
                      key={location.id}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="contact-location-name">{location.locationName}</span>
                      <span className="contact-address-line">{location.address}</span>
                      <span className="contact-address-line">{cityLine}</span>
                    </a>
                  );
                })}
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
